export default __webpack_public_path__ + "static/media/travellers_Pay_employ.5909445c.jpg";